import vueAppleLogin from 'vue-apple-login';
import dayjs from 'dayjs';

export default defineNuxtPlugin((nuxtApp) => {
    const config = useRuntimeConfig();

    nuxtApp.vueApp.use(vueAppleLogin, {
        clientId: config.public.appleClientId,
        scope: 'name email',
        redirectURI: config.public.appleRedirectUrl,
        state: dayjs().format('YYYY-MM-DD HH:mm:ss'),
        usePopup: true
    });
})